/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { SysqueElectricalState, SysquePopupConfig, ToolGroup } from '@hcworkspace/sysque/toolbelt/feature';
import { DownloadFamiliesReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/download-families-return-codes';
import { ElectricalSettingsReturnCodes } from 'libs/sysque/toolbelt/feature/src/lib/models/electrical-settings-return-codes';

export interface IAppShellFacade {
  dispatchShowSysquePopupAction(action: { sysquePopupConfig: SysquePopupConfig }): void;
  selectSysquePopup(): Observable<SysquePopupConfig>;
  selectShowAddFittingResultPanel(): Observable<boolean>;
  selectAddFittingMode(): Observable<boolean>;
  selectToolBeltItems(): Observable<ToolGroup[]>;
  getStorage(key: string): string | SysqueElectricalState;
  onDoneAction(): void;
  updateStorage(key: string, value: string): void;
  initializeData(): void;
  downloadMissingFamilies(): Observable<boolean>;
  checkInvalidShortcuts(): Observable<ElectricalSettingsReturnCodes>;
  sendPopupRoutingAction(itemName: any, width: number, height: number): void;
  updateLocalStorage(key: string, value: any): void;
  updateGenericFittings(): Observable<DownloadFamiliesReturnCodes>;
  checkIfMissingFamilies(): Observable<DownloadFamiliesReturnCodes>;
  getLocalStorage(key: string): any;
}

export const APP_SHELL_FACADE_TOKEN = new InjectionToken<IAppShellFacade>('APP_SHELL_FACADE_TOKEN');
